import { createLabeledMessages } from '@gef-ui/localization/messageUtils';

/* eslint-disable max-len */
const fileUpload = {
	dragFiles: 'Přetáhni soubory sem nebo',
	uploadFile: 'Nahraj soubor',
	acceptedFileTypeMessage:
		'Soubor {{name}} nemá žádnou z povolených přípon: asc, bmp, dib, doc, docx, eml, gif, htm, html, jfif, jpeg, jpg, msg, pcx, pdf, png, rtf, tif, tiff, txt, xls, xlsx, xml, zfo',
	maxSizeMessage: 'Soubor {{name}} překročil maximální velikost {{limit}}MB',
	maxSizeOverallMessage: 'Vložené soubory překročili maximální velikost {{limit}}MB',
	maxFileCountExtended: 'Maximální počet přiložených souborů je {{limit}}',
	maxFileNameSizeExtended: 'Maximální délka názvu souboru je {{limit}} znaků',
};

export default Object.assign({}, fileUpload, createLabeledMessages(fileUpload));
